import React, { useEffect, useContext, useState, useRef } from 'react';
import Context from '../../context/context';
import jsPDF from 'jspdf';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import html2canvas from 'html2canvas';
import emailjs from 'emailjs-com';
import { fetchTrainsTermsValue } from "../../apiCall";

function Success() {
  const { state, dispatch } = useContext(Context);
  const [saveTravel, setSaveTravel] = useState();
  const [travelURL, setTravelURL] = useState();
  const [travelURLimg, setTravelURLimg] = useState();
  const [editURL, setEditURL] = useState();
  const [unixTime, setUnixTime] = useState();
  const [qrLoaded, setQrLoaded] = useState(false);
  const containerRef = useRef(null);
  const [trainsTermsValue, setTrainsTermsValue] = useState("");
  

  const resetState = () => dispatch({ type: "RESET" });

  useEffect(() => {
    resetState();
    const travel = localStorage.getItem('saveTravel');

    if (travel && !saveTravel) {
      const parsedData = JSON.parse(travel);
      setSaveTravel(parsedData);

      const dateParts = parsedData.data.date.split('/');
      const year = '20' + dateParts[2];
      const month = (parseInt(dateParts[1]) - 1).toString().padStart(2, '0');
      const day = dateParts[0].padStart(2, '0');
      const unixTimestamp = new Date(parseInt(year), parseInt(month), parseInt(day)).getTime() / 1000;
      setUnixTime(unixTimestamp);

      const qrCodeUrl = `https://pych-customers.firebaseapp.com/verifyInvite/${parsedData.id}/${parsedData.data.travelType}/${unixTimestamp}`;
      setTravelURL(qrCodeUrl);

      const qrCodeImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrl)}`;
      setTravelURLimg(qrCodeImageUrl);

      const url = `https://pych-customers.firebaseapp.com/${parsedData.id}/${parsedData.data.travelType}/${unixTimestamp}`;
      setEditURL(url);
    }
  }, [saveTravel]);


  const resendEmailOnSaveTravel = async () => {
    let  template  =  'template_94u1nws';
     console.log(saveTravel.data )
    if(saveTravel.data.travelBack){
      template = 'template_szcehms' ; 
    }
    let travelType = saveTravel.data.travelType == 'sadir' ? 'סדירה' : 'פרטית';
    let orbit = saveTravel.data.orbit.name;
    let type = saveTravel.data.travelType;
    let date = saveTravel.data.date;
    let time = saveTravel.data.time;
    let amount = saveTravel.data.amount;
    let pricePercent = saveTravel.data.pricePercent.toFixed(2);
    let priceBackPercent = saveTravel.data.travelBack.priceBackPercent.toFixed(2);
    let name = saveTravel.data.name;
    let phone  = saveTravel.data.phone;
    let localID = saveTravel.data.localID;

const dateParts = date.split('/');
const timeParts = time.split(':');

const year = '20' + dateParts[2];
const month = parseInt(dateParts[1]) - 1; 
const day = parseInt(dateParts[0]);
const hours = parseInt(timeParts[0]);
const minutes = parseInt(timeParts[1]);

const unixTimestamp = new Date(
  parseInt(year),
  month,
  day,
  hours,
  minutes
).getTime();

    let qrCodeUrl = `https://pych-customers.firebaseapp.com/verifyInvite/${saveTravel.data.id}/${type}/${unixTimestamp}`;
    let qrCodeImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrl)}`;

    let qrCodeUrlBack = `https://pych-customers.firebaseapp.com/verifyInvite/${saveTravel.data.id}/${type}/${unixTimestamp}`;
    let qrCodeImageUrlBack = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrl)}`;

    

  emailjs.init('XsgbOlGB9X2UF4_Yn');

  let templateParams  = {

    travelType: travelType,
    orbit:  orbit,
    type:   type,
    date:   date,
    time:   time,
    amount : amount , 
    name : name , 
    phone : phone , 
    localID : localID , 
    pricePercent : pricePercent , 
    unixTimestamp : unixTimestamp , 
    qrCodeUrl:   `https://pych-customers.firebaseapp.com/verifyInvite/${saveTravel.data.id}/${type}/${unixTimestamp}` , 
    qrCodeImageUrl:  `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrl)}` , 
    email: saveTravel.data.mail,    

  };

  if(saveTravel.data.travelBack){
      let orbitBack = saveTravel.data.travelBack.orbit.name;
      templateParams = {
        ...templateParams,
        orbitBack: orbitBack,
        typeBack: saveTravel.data.travelBack.type,
        dateBack: saveTravel.data.travelBack.date,
        timeBack: saveTravel.data.travelBack.time,
        pricePercentBack: priceBackPercent,
        qrCodeUrlBack:   `https://pych-customers.firebaseapp.com/verifyInvite/${saveTravel.data.id}/${type}/${unixTimestamp}` , 
        qrCodeImageUrlBack:  `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrCodeUrlBack)}` , 

      };
    }


  emailjs.send('service_t4dgefh', template, templateParams)
    .then(() => {
      alert('המשוב נשלח בהצלחה');
    })
    .catch((error) => {
        console.log('Sending email with params:', templateParams);
      console.log('ERROR...', error);
      alert('שגיאה בשליחת המשוב: ' + (error.text || error.message || JSON.stringify(error)));
    });
}


  const handleDownloadPDF = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const newPageSections = containerRef.current?.querySelectorAll('.newPage');
    if (!newPageSections || newPageSections.length === 0) return;

    for (let i = 0; i < newPageSections.length; i++) {
      const section = newPageSections[i];

      // Save original width and set temporary PDF width
      const originalWidth = section.style.width;
      section.style.width = "794px";

      const canvas = await html2canvas(section, {
        scale: 3,
        useCORS: true,
        logging: false,
        windowWidth: section.scrollWidth,
        windowHeight: section.scrollHeight
      });

      // Restore original width
      section.style.width = originalWidth;

      const imgData = canvas.toDataURL('image/png', 1.0);
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight > pageHeight ? pageHeight : imgHeight);
    }

    pdf.save('קבלה מפאייכלה.pdf');
  };

   fetchTrainsTermsValue((response) => {
        if (response && response.data) {
          setTrainsTermsValue(response.data.trainsTerms);
        }
      });

  useEffect(() => {
    if (saveTravel && travelURLimg && qrLoaded) {
      setTimeout(() => {
        handleDownloadPDF();
        resendEmailOnSaveTravel()
      }, 500);
    }
  }, [saveTravel, travelURLimg, qrLoaded]);


  return (
    <div>
      <TopBaner />
      <SideBar />
      <style>{`
        .newPage {
          width: 400px; /* Screen display */
          max-width: 100%;
          margin: 0 auto;
          padding: 32px;
          box-sizing: border-box;
          background: white;
          font-family: 'Arial', sans-serif;
          border: 1px solid #ddd;
          border-radius: 12px;
        }
        .parameter {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px dashed #eee;
        }
      `}</style>

      <div className="paymentCard" ref={containerRef} style={{ padding: '2rem' }}>
        {saveTravel ? (
          <div style={{ textAlign: 'center' }}>
            {/* First Page */}
            <div className="newPage">
              <img style={{ margin: '0', height: '100px' }} src="pycBlueIogo.png" alt="logo-pych" />
              <h6 className="headerBack">: נסיעת הלוך</h6>
              <div className="parameter"><span>{saveTravel.data.travelType == 'sadir' ? 'סדירה ': 'פרטית'}</span><span>: סוג נסיעה</span></div>
              <div className="parameter"><span>{saveTravel.data.date}</span><span>: תאריך</span></div>
              <div className="parameter"><span>{saveTravel.data.time}</span><span>: שעה</span></div>
              <div className="parameter"><span>{saveTravel.data.orbit.hebrewAdress}</span><span>: מסלול</span></div>
              {saveTravel.data.orbit.note ?<div className="parameter"><span>{saveTravel.data.orbit.note}</span><span>: הערה</span></div>: <> </>}

              {saveTravel.data.travelBack && (
                <>
                  <h6 className="headerBack">: נסיעת חזור</h6>
                  <div className="parameter"><span>{saveTravel.data.travelBack.travelType}</span><span>: סוג נסיעה</span></div>
                  <div className="parameter"><span>{saveTravel.data.travelBack.date}</span><span>: תאריך</span></div>
                  <div className="parameter"><span>{saveTravel.data.travelBack.time}</span><span>: שעה</span></div>
                  <div className="parameter"><span>{saveTravel.data.travelBack.orbit.name}</span><span>: מסלול</span></div>
              {saveTravel.data.travelBack.orbit.note ?<div className="parameter"><span>{saveTravel.data.travelBack.orbit.note}</span><span>: הערה</span></div>: <> </>}
                </>
              )}

              <h6 className="headerBack">: פרטי נוסע</h6>
              <div className="parameter"><span>{saveTravel.data.name}</span><span>: שם</span></div>
              {/* <div className="parameter"><span>{saveTravel.data.englishName}</span><span>: שם באנגלית</span></div> */}
              <div className="parameter"><span>{saveTravel.data.flightNumber}</span><span>: מספר טיסה</span></div>
              <div className="parameter"><span>{saveTravel.data.amount}</span><span>: כמות</span></div>
              <div className="parameter"><span>{saveTravel.data.phonNumber}</span><span>: טלפון</span></div>
              <div className="parameter"><span>{saveTravel.data.notes}</span><span>: הערות</span></div>
              {/* <div className="parameter"><span>{saveTravel.id}</span><span>: מזהה נסיעה</span></div> */}
              <div className="parameter"><span>{saveTravel.data.localID}</span><span>: מזהה לקוח</span></div>
              <p>: חתימה</p>
              <br />
              <img src={saveTravel.data.signature} alt="signature" style={{ maxWidth: '200px' }} />
            </div>

            <br />

            {/* Second Page */}
            <div className="newPage">
              {travelURLimg && saveTravel.data.originData.tripType !== 'רכבת' && (
                <img
                  src={travelURLimg}
                  alt="QR"
                  style={{ marginTop: '10px' }}
                  onLoad={() => setQrLoaded(true)}
                />
              )}
              <p style={{ fontWeight: 'bold', marginTop: '10px' }}>קבלה וכרטיס ישלחו גם למייל</p>
              <p style={{ fontWeight: 'bold' }}>נסיעה טובה</p>
              <p style={{ fontWeight: 'bold' }}>צוות פאייכלה</p>
            </div>

            {/* Third Page - Terms */}
            {(saveTravel.data.originData.tripType == 'רכבת') ? (
              <div
                className="newPage"
                style={{ textAlign: 'right', direction: 'rtl' }}
                dangerouslySetInnerHTML={{ __html: trainsTermsValue }}
              />
            ) : (
              saveTravel.data.terms && (
                <div
                  className="newPage"
                  style={{ textAlign: 'right', direction: 'rtl' }}
                  dangerouslySetInnerHTML={{ __html: saveTravel.data.terms }}
                />
              )
            )}
          </div>
        ) : null}

        <button className='optionsBtn pdfBtn' onClick={handleDownloadPDF}>הורד קובץ PDF</button>
      </div>
    </div>
  );
}

export default Success;
